export function formatUserName(name: string, organization?: string): string {
    if (!name) return ''
    if (organization) return `${name} (${organization})`
    return name
}
